export const COUNTRIES = {
  CANADA: 'Canada',
  MEXICO: 'Mexico',
  UNITED_STATES: 'United States',
};
